import { render, staticRenderFns } from "./DoudianProductEditorDialog.vue?vue&type=template&id=50217a32&scoped=true"
import script from "./DoudianProductEditorDialog.vue?vue&type=script&lang=js"
export * from "./DoudianProductEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./DoudianProductEditorDialog.vue?vue&type=style&index=0&id=50217a32&prod&scoped=true&lang=css"
import style1 from "./DoudianProductEditorDialog.vue?vue&type=style&index=1&id=50217a32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50217a32",
  null
  
)

export default component.exports